// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { IProfileGetAttrs, IProfileUpdateAttrs } from 'interfaces/back-office/personal-data/profile/profile-view.interface'

const useProfile = () => {
  // Hook
  const {
    profile: {
      profile_loading,
      profile_profileData,
      profile_companyData,
      profile_CLEAR_PROFILE,
      profile_fetchProfile: profileFetchProfile,
      profile_updateProfile: profileUpdateProfile,
    },
  } = useStores()

  /**
   * @description Fetch profile
   *
   * @param {IProfileGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const profile_fetchProfile = useCallback(async (payload: IProfileGetAttrs): Promise<void> => {
    return new Promise((resolve, reject) => {
      profileFetchProfile({
        requestConfig: { ...payload.requestConfig },
        onSuccess: resolve,
        onError: reject,
      })
    })
    // eslint-disable-next-line
  }, [])

  /**
   * @description Update profile
   *
   * @param {IProfileUpdateAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const profile_updateProfile = useCallback(async (payload: IProfileUpdateAttrs): Promise<void> => {
    return new Promise((resolve, reject) => {
      profileUpdateProfile({
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
        onSuccess: resolve,
        onError: reject,
      })
    })
    // eslint-disable-next-line
  }, [])

  return {
    profile_loading,
    profile_profileData,
    profile_companyData,
    profile_CLEAR_PROFILE,
    profile_fetchProfile,
    profile_updateProfile,
  }
}

export { useProfile }
